export function ok(value) {
  return {
    ok: true,
    value: value,
    error: undefined,
  }
}

export function err(error) {
  return {
    ok: false,
    value: undefined,
    error: error,
  }
}
